import type { SessionCurriculumSlice } from '../types/coursePlan';

const DIMENSION_LABELS: Record<SessionCurriculumSlice['dimensionDominante'], string> = {
  OA: 'Conocimiento',
  OAH: 'Habilidad',
  OAA: 'Actitud',
};

export function curriculumDimensionName(
  dimension: SessionCurriculumSlice['dimensionDominante'],
): string {
  return DIMENSION_LABELS[dimension];
}

export function curriculumDimensionBadgeLabel(slice: SessionCurriculumSlice): string {
  const label = DIMENSION_LABELS[slice.dimensionDominante];
  const codeSuffix = slice.dimensionCode?.trim() || slice.dimensionDominante;
  return `Dimensión: ${label} (${codeSuffix})`;
}

export function curriculumDimensionBadgeClass(
  dimension: SessionCurriculumSlice['dimensionDominante'],
): string {
  switch (dimension) {
    case 'OA':
      return 'border border-gray-800 bg-transparent text-gray-900';
    case 'OAH':
      return 'border border-gray-400 bg-gray-50 text-gray-700';
    case 'OAA':
      return 'border border-dashed border-gray-400 bg-transparent text-gray-600';
    default:
      return 'border border-gray-300 bg-transparent text-gray-600';
  }
}
